<template>
    <div id="home">
        <div class="banner">
            <img src="../../assets/img/banner.png" draggable="false" />
        </div>
        <div class="wrap">
            <div class="home_title">视频讲座</div>
            <div class="home_desc">丰富的骨科学术讲座视频，免费在线观看，做中国骨科学术资源分享，点击查看更多分专业体验优质学术资源！</div>
            <div class="more">
                <router-link to="/video" tag="span">更多&gt;&gt;</router-link>
            </div>
            <DataList :dataArray="videoList" @transfer="toDetail" />
        </div>
        <div class="wrap" style="background-color: #fff;">
            <div class="home_title">独家课程</div>
            <div class="home_desc">骨今学院独家高级视频课程，均为权威专家系统授课，深入讲解！在线学习新模式，助力专业水平提升！</div>
            <div class="more">
                <router-link to="/course" tag="span">更多&gt;&gt;</router-link>
            </div>
            <DataList :dataArray="courseList" @transfer="toDetail" />
        </div>
        <!-- <div class="wrap">
            <div class="home_title">线下培训</div>
            <div class="home_desc">
                骨今学院高级骨科培训班，各专业、地区领军骨科专家倾囊相授。理论实践+互动讨论，现场与专家面对面学习交流！
            </div>
            <div class="more">
                <router-link to="/train" tag="span">更多&gt;&gt;</router-link>
            </div>
            <TrainList :dataArray="trainList" />
        </div> -->
    </div>
</template>

<script>
import DataList from "../Common/DataList";
import TrainList from "../Common/TrainList";
import { async } from "q";

export default {
    name: "Home",
    data() {
        return {
            userId: localStorage.getItem("userId") || "",
            videoList: [],
            courseList: [],
            trainList: []
        };
    },
    components: { DataList, TrainList },
    created() {
        this.getDataList("videoList", 2);
    },
    mounted() {
        this.getDataList("courseList", 1);
        this.getTrainData();
        this.addDataBuried();
    },
    methods: {
        addDataBuried() {
            let headers = {
                equipmentType: "3", //设备类型： 1：安卓、  2 ：IOS 、 3 ： H5
                phoneModel: "", //手机型号
                appVersionNumber: "" //app版本号
            };
            this.$axios
                .post(
                    "/SD/statistic/addDataBuried",
                    this.$qs.stringify({
                        usergid: this.userId,
                        moduleType: "11",
                        subModuleType: "1",
                        locationType: "1",
                        disMobile: "PC"
                    }),
                    {
                        headers
                    }
                )
                .then(res => {});
        },
        getDataList(typeName, typeNo) {
            let params = {
                category: typeNo,
                charge: 1,
                keyword: "",
                pageNum: 1,
                rank: "updateTime",
                type: ""
            };
            this.$loading({
                background: "rgba(0, 0, 0, 0.7)",
                text: "拼命加载中"
            });
            this.$axios
                .post("/web/course/queryCourseList", this.$qs.stringify(params))
                .then(res => {
                    let data = res.data;
                    if (data.code == "1") {
                        let dtArr = data.result_data[typeName];
                        this[typeName] = dtArr.splice(0, 10);
                    } else {
                        this.$message.error(data.message);
                    }
                    this.$loading().close();
                })
                .catch(err => {
                    this.$loading().close();
                    this.$message.error("获取失败", err);
                });
        },
        getTrainData() {
            this.$axios
                .post("/web/academy/queryAcademy", this.$qs.stringify({ pageCount: 20, pageIndex: 1 }))
                .then(res => {
                    let data = res.data;
                    if (data.code == "1") {
                        this.trainList = data.result_data.splice(0, 8);
                    } else {
                        this.$message.error(data.message);
                    }
                })
                .catch(err => {
                });
        },
        toDetail(dic) {

            if(dic.type == 2){
                this.$router.push({ path: "/video/"+dic.gid, params: { gid: dic.gid }});
            }else{
                this.$router.push({ path: "/classVideo", params: { gid: dic.gid }, query: { gid: dic.gid }});
            }
        }
    }
};
</script>

<style scoped src="../../assets/css/home.css"></style>
